module.exports = __webpack_public_path__ + "img/placeholdersimilies.9459d8ca.jpg";